<template>
  <div>
    <c-modal
      v-if="showModal"
      title="Giveaways"
      size="md"
      @close="closeModal"
    >
      <div class="modal-body">
        <div
          class="giveaway-items"
          v-for="(item, index) in giveaways"
          :key="item.id"
        >
          <div class="giveaway-info">
            <!-- Image -->
            <img
              class="giveaway-item-img"
              :src="item.image_url"
              alt="Giveaway Logo"
            />

            <!--          TODO: add styles in the future -->
            <div class="description" v-if="item.description" v-html="item.description"></div>
          </div>

          <div class="giveaway-buttons">
            <c-button
              v-if="!item.is_registered"
              fill
              uppercase
              theme="primary"
              icon="fa-gift-card"
              @click="enterToGiveAway(index)"
              :show-indicator="item.loading"
              :disabled="!isAttendee"
            >Enter {{ !isAttendee ? '*' : '' }}</c-button>

            <!-- Registered Button -->
            <c-button
              v-if="item.is_registered"
              fill
              uppercase
              theme="success"
              icon="fa-circle-check"
              disabled
            >Registered</c-button>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <c-button
          theme="default"
          size="md"
          icon="fa-close"
          @click="closeModal"
          uppercase
          fill
        >Close</c-button>
      </div>
    </c-modal>
  </div>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    isAttendee: {
      type: Boolean,
      default: false
    },
    giveaways: {
      type: Array,
      default: () => []
    },
    enterToGiveAway: {
      type: Function,
      default: () => {}
    }
  },
  mounted() {},
  data() {
    return {
      attendeeId: this.$route.params.attendeeId,
      sponsorId: this.$route.params.sponsorId,
    }
  },
  methods: {
    closeModal() {
      this.$emit('update:showModal', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.giveaway-items {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
  margin-bottom: 15px;
}

.giveaway-info {
  display: flex;
  align-items: center;
  gap: 15px;
  flex: 1;
  min-width: 0;
}

.giveaway-buttons {
  flex-shrink: 0;
}

.giveaway-item-img {
  margin-right: 1.2rem;
  width: 120px;
  height: auto;
}

@media (max-width: 766px) {
  .giveaway-items {
    flex-direction: column;
  }

  .giveaway-info {
    flex-direction: column;
  }

  .giveaway-item-img {
    margin-right: 0;
  }
}
</style>